module.exports = __webpack_public_path__ + "img/R. Jaim Sued.b6d801dd.png";